import { DEFAULT_LIMIT } from '../constants/pagination';
import { IGetProjectsListResponseSchema } from '../repositories/countryside-constructors/entities/v1_entities/GetProjectsListResponseSchema';
import { IBuildersProjectsData } from '../types/buildersProjects';

export const prepareBuildersProjectsData = (response: IGetProjectsListResponseSchema): IBuildersProjectsData => {
  return {
    page: response.page || 0,
    limit: response.limit || DEFAULT_LIMIT,
    total: response.total || 0,
    projectsList: response.projectsList,
    location: response.location,
    breadcrumbs: response.breadcrumbs,
  };
};
